// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"dcc171b8","242":"1d5f9a50","293":"58f11cde","412":"c2c89769","434":"753356f7","460":"d8c90554","703":"e5a2e931","799":"0945c216","896":"85abc4eb"}[chunkId] + ".chunk.js";
};